import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [{
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue'),
    meta:{     
      title: '官网——黄海科学技术研究院'
    }
  }, {
    path: '/information',
    name: 'information',
    component: () => import('../views/information.vue'),
    meta:{     
      title: '简介——黄海科学技术研究院'
    }
  }, {
    path: '/informationdetails',
    name: 'informationdetails',
    component: () => import('../views/informationdetails.vue'),
    meta:{     
      title: '详情——黄海科学技术研究院'
    }
  }, {
    path: '/timer',
    name: 'timer',
    component: () => import('../views/timer.vue'),
    meta:{     
      title: '黄海科学技术研究院'
    }
  }, {
    path: '/laboratory',
    name: 'laboratory',
    component: () => import('../views/laboratory.vue'),
    meta:{     
      title: '黄海科学技术研究院'
    }
  }, {
    path: '/personnel',
    name: 'personnel',
    component: () => import('../views/personnel.vue'),
    meta:{     
      title: '黄海科学技术研究院'
    }
  }, {
    path: '/team',
    name: 'team',
    component: () => import('../views/team.vue'),
    meta:{     
      title: '黄海科学技术研究院'
    }
  }, {
    path: '/structure',
    name: 'structure',
    component: () => import('../views/structure.vue'),
    meta:{     
      title: '黄海科学技术研究院'
    }
  }, {
    path: '/article',
    name: 'article',
    component: () => import('../views/article.vue'),
    meta:{     
      title: '黄海科学技术研究院'
    }
  },{
    path: '/institution-article',
    name: 'article',
    component: () => import('../views/institution-article.vue'),
    meta:{     
      title: '黄海科学技术研究院'
    }
  },{
    path: '/lab-article',
    name: 'article',
    component: () => import('../views/lab-article.vue'),
    meta:{     
      title: '黄海科学技术研究院'
    }
  }, {
    path: '/project',
    name: 'project',
    component: () => import('../views/project.vue'),
    meta:{     
      title: '黄海科学技术研究院'
    }
  },{
    path: '/introduction',
    name: 'introduction',
    component: () => import('../views/introduction.vue'),
    meta:{     
      title: '黄海科学技术研究院'
    }
  },{
    path: '/timerdetails',
    name: 'timerdetails',
    component: () => import('../views/timerdetails.vue'),
    meta:{     
      title: '黄海科学技术研究院'
    }
  },{
    path: '/wrongpage',
    name: 'wrongpage',
    component: () => import('../views/wrongpage.vue'),
    meta:{     
      title: '错误'
    }
  },{
    path: '*',
    name: 'page404',
    component: () => import('../views/page404.vue'),
    meta:{     
      title: '404'
    }
  }]
  
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
export default router
